import { myGymExercises as types } from '../actions/actiontypes'

const initState = {
  ongoing: [],
  count: {},
  all: [],
  site: [],
  chainSite: [],
  global: [],
  zone: [],
  error: [],
  searchResult: [],
  searchOngoing: [],
}

export function myGymExercisesReducer(state = initState, action) {
  switch (action.type) {
    case 'STORE_RESET':
      return Object.assign({}, initState)
    case types.GET:
      return {
        ...state,
        ongoing: [...state.ongoing, 'all']
      }
    case types.ADD_NEW:
      return {
        ...state,
        all: [...state.all, action.exercise]
      }
    case types.RESPONSE:
      return {
        ...state,
        ongoing: state.ongoing.filter(o => o !== 'all'),
        all: action.exercises
      }
    case types.GET_FAIL:
      return {
        ...state,
        ongoing: state.ongoing.filter(o => o !== 'all'),
        error: [...state.error, action.error]
      }
    case types.GET_EXERCISES:
      return {
        ...state,
        ongoing: [...state.ongoing, action.scope]
      }
    case types.GET_EXERCISES_RESPONSE:
      return {
        ...state,
        ongoing: state.ongoing.filter(o => o !== action.scope),
        [action.scope]: action.exercises,
        count: { ...state.count, [action.scope]: action.count }
      }
    case types.GET_EXERCISES_FAILED:
      return {
        ...state,
        ongoing: state.ongoing.filter(o => o !== action.scope),
        error: [...state.error, action.error],
      }

    case types.SEARCH_FOR_EXERCISES:
      return {
        ...state,
        searchOngoing: [...state.searchOngoing, { scope: action.scope, what: 'searching' }],
      }
    case types.SEARCH_FOR_EXERCISES_RESPONSE:
      return {
        ...state,
        searchOngoing: [...state.searchOngoing.filter(o => o.scope !== action.scope), { scope: action.scope, what: 'done' }],
        searchResult: action.exercises,
      }
    case types.SEARCH_FOR_EXERCISES_FAILED:
      return {
        ...state,
        searchOngoing: state.searchOngoing.filter(o => o.scope !== action.scope),
        searchResult: [],
        error: [...state.error, action.error],
      }
    case types.SEARCH_FOR_EXERCISES_CLEAR:
      return {
        ...state,
        searchOngoing: [],
        searchResult: [],
      }
    case types.FILTER_OUT_EXERCISE:
      return {
        ...state,
        all: state.all.filter(item => item._id !== action.exercise),
        site: state.site.filter(item => item._id !== action.exercise),
        chainSite: state.chainSite.filter(item => item._id !== action.exercise),
        global: state.global.filter(item => item._id !== action.exercise),
        zone: state.zone.filter(item => item._id !== action.exercise),
        searchResult: state.searchResult.filter(item => item._id !== action.exercise),
      }
    case types.SILENT_GET_COUNT:
      return {
        ...state,
        count: { ...state.count, [action.scope]: action.count }
      }
    default:
      return state
  }
}